import classNames from 'classnames';
import { useTranslations } from '../context/TranslationContext';

const EmptyPlaceholder = ({ animation, title, description, classes, size }) => {
    const { t } = useTranslations();
    return (
        <div className={classNames('empty-state-placeholder', classes)}>
            {animation && (
                <div
                    className='empty-state-placeholder-animation init-animation'
                    data-animation_name='fishing-animation'
                    data-animation_size={size}
                    data-animation_loop='true'
                    data-animation_position='static'
                ></div>
            )}

            <div className='empty-state-placeholder-title'>{title || t('Nothing here yet')}.</div>
            {description && (
                <div className='empty-state-placeholder-description'>{description}</div>
            )}
        </div>
    );
};

EmptyPlaceholder.defaultProps = {
    title: null,
    description: null,
    animation: true,
    classes: null,
    size: 150,
};

export default EmptyPlaceholder;
